module.exports = __webpack_public_path__ + "img/arrow.3205dc95.svg";